import { createContext, useContext } from 'react';

export const OrganizationContext = createContext(null);

export const useOrganization = () => {
    const context = useContext(OrganizationContext);
    if (!context) {
        throw new Error('useOrganization must be used within an OrganizationProvider');
    }
    return context;
};
